<mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="loading">
  <div class="page-container order-main">
    @if (data.order?.id) {
    <div class="page-header">
      <button mat-icon-button routerLink="/orders">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <div>
        <h2 class="page-title">Visualizar Pedido</h2>
        <p class="page-subtitle">Detalhes do pedido selecionado</p>
      </div>
    </div>
    <div class="order-details">
      <p class="section-title mb-3">Pedido</p>
      <div class="grid grid-cols-4 gap-3 mt-2 mb-4">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Código Cardealer</mat-label>
          <input disabled matInput type="text" [value]="data.order.codeOrder || ''" />
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Código Cliente</mat-label>
          <input disabled matInput type="text" [value]="data.order.codeOrderClient || ''" />
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Data</mat-label>
          <input disabled matInput type="text" [value]="data.order?.date | date:'dd/MM/yyyy'" />
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Status</mat-label>
          <input disabled matInput type="text" [value]="statusMap[data.order.status] || ''" />
        </mat-form-field>
      </div>
      <p class="section-title mb-3">Montadora</p>
      <div class="grid grid-cols-4 gap-3 mt-2 mb-4">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Código</mat-label>
          <input disabled matInput type="text" [value]="data.order.automaker?.code || ''" />
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Razão Social</mat-label>
          <input disabled matInput type="text" [value]="data.order.automaker?.company?.tradeName || ''" />
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>CNPJ</mat-label>
          <input disabled matInput type="text" mask="AA.AAA.AAA/0000-00" [ngModel]="automakerDocument" />
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>UF</mat-label>
          <input disabled matInput type="text"
            [value]="data.order.automaker?.company?.address?.city?.state?.code || ''" />
        </mat-form-field>
      </div>
      <p class="section-title mb-3">Concessionária</p>
      <div class="grid grid-cols-4 gap-3 mt-2 mb-4">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Código</mat-label>
          <input disabled matInput type="text" [value]="data.order.dealership?.code || ''" />
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Razão Social</mat-label>
          <input disabled matInput type="text" [value]="data.order.dealership?.company?.tradeName || ''" />
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>CNPJ</mat-label>
          <input disabled matInput type="text" mask="AA.AAA.AAA/0000-00" [ngModel]="dealershipDocument" />
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>UF</mat-label>
          <input disabled matInput type="text"
            [value]="data.order.dealership?.company?.address?.city?.state?.code || ''" />
        </mat-form-field>
      </div>
      <p class="section-title mb-3">Distribuidor Exclusivo</p>
      <div class="grid grid-cols-4 gap-3 mt-2 mb-2">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Código</mat-label>
          <input disabled matInput type="text" [value]="data.order.distributor?.code || ''" />
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Razão Social</mat-label>
          <input disabled matInput type="text" [value]="data.order.distributor?.company?.tradeName || ''" />
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>CNPJ</mat-label>
          <input disabled matInput type="text" mask="AA.AAA.AAA/0000-00" [ngModel]="distributorDocument" />
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>UF</mat-label>
          <input disabled matInput type="text"
            [value]="data.order.distributor?.company?.address?.city?.state?.code || ''" />
        </mat-form-field>
      </div>
    </div>
    @if (!data.order.distributor) {
    <div class="mt-4 mb-6">
      <mat-accordion>
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title style="color: red">
              <mic-icon icon="warning" class="mr-2" /> Atenção! Este pedido não pode ser atendido.
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-divider></mat-divider>
          <p class="mb-3">Não há distribuidor exclusivo ativo para a região e linha de produto da concessionária
            informada.</p>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    }
    <div class="mt-4 mb-6">
      @if (data.order.distributor) {
      <div class="flex flex-row-reverse mb-3">
        <button mat-flat-button color="primary" class="mic-btn-icon-left" (click)="clearForm()">
          <mat-icon>refresh</mat-icon><span>Recarregar</span>
        </button>
      </div>
      }
      <mat-accordion multi>
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>Itens do Pedido</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="mt-3">
            <mic-table class="table-stripped" [config]="tableConfig" [dataSource]="orderItemsDataSource">
              <ng-container *micCellTemplate="let item; name: 'partNumber'">
                @if (!item.product?.cai) {
                <span style="color: red">Part Number não encontrado</span>
                }
                @if (item.product?.cai && item.sellout === 0) {
                <span style="color: red">Preço não encontrado</span>
                }
              </ng-container>
            </mic-table>
          </div>
        </mat-expansion-panel>
        @if (data.invoices.length > 0 && data.order.distributor) {
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>Lançamentos</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="flex flex-col justify-between">
            @for (invoice of data.invoices; track invoice; let i = $index) {
            <div class="mb-4">
              @if (i > 0) {
              <div class="mb-4"><mat-divider /></div>
              }
              <p class="date-title">{{ formatIsoDate(invoice.invoiceDate) }}</p>
              <mic-table class="table-stripped" [config]="invoiceTableConfig"
                [dataSource]="mapInvoiceDataSource(invoice.items)"></mic-table>
              <div class="flex flex-row justify-between items-center mr-3 gap-3">
                <p>
                  Data informada da Nota Fiscal: <b>{{ formatIsoDate(invoice.invoiceDate) }}</b>
                </p>
                <div class="flex flex-row items-center gap-3">
                  <button mat-flat-button color="secondary" class="mic-btn-icon-left"
                    (click)="downloadInvoiceFile(invoice.id)">
                    <mat-icon>open_in_new</mat-icon><span>Visualizar Nota Fiscal</span>
                  </button>
                  <span>
                    <b>Total: {{ formatCurrency.format(invoice.totalValue) }}</b>
                  </span>
                </div>
              </div>
            </div>
            }
          </div>
        </mat-expansion-panel>
        }
        @if (orderItemsWithPriceDataSource?.data?.length > 0 && data.order.distributor) {
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>Novo Lançamento</mat-panel-title>
          </mat-expansion-panel-header>
          <form [formGroup]="invoiceForm">
            <div class="flex flex-col justify-between">
              <div>
                <p><b>Itens</b></p>
                <div formArrayName="items">
                  <mic-table class="table-stripped" [config]="orderItemsWithPriceTableConfig"
                    [dataSource]="orderItemsWithPriceDataSource">
                    <ng-container *micCellTemplate="let item; name: 'cancelItem'">
                      @if (item.sellout > 0) {
                      <button [disabled]="isDisabled(item)" mat-icon-button color="primary"
                        matTooltipClass="big-tooltip" matTooltip="Cancelar item" (click)="cancelItem(item)">
                        <mat-icon style="font-size: 22px;" class="cancel-icon">cancel</mat-icon>
                      </button>
                      }
                    </ng-container>
                    <ng-container *micCellTemplate="let item; name: 'quantityInvoice'">
                      @if (item.product?.cai && item.sellout > 0) {
                      <div [formGroupName]="item.index" class="flex flex-col">
                        @if (!isCanceled(item)) {
                        <input [min]="0" [max]="item.quantity - item.quantityServed" type="number"
                          class="w-100 quantity-input" formControlName="quantity" />
                        }
                        @if (isCanceled(item)) {
                        <span style="color: red">Item cancelado</span>
                        }
                        @if (invoiceItems.at(item.index)?.get('quantity')?.hasError('max')) {
                        <div class="mb-2">
                          <span style="color: red">O valor máximo permitido é {{ item.quantity - item.quantityServed
                            }}</span>
                        </div>
                        }
                        @if (invoiceItems.at(item.index)?.get('quantity')?.hasError('min')) {
                        <div class="mb-2">
                          <span style="color: red">O valor mínimo permitido é 0</span>
                        </div>
                        }
                      </div>
                      }
                      @if (!item.product?.cai) {
                      <span style="color: red">Part Number não encontrado</span>
                      }
                      @if (item.product?.cai && item.sellout === 0) {
                      <span style="color: red">Preço não encontrado</span>
                      }
                    </ng-container>
                    <ng-container *micCellTemplate="let item; name: 'totalPrice'">
                      {{ formatCurrency.format(invoiceItems.at(item.index).get('totalPrice').value) }}
                    </ng-container>
                    <ng-container *micCellTemplate="let item; name: 'totalPrice'">
                      {{ formatCurrency.format(invoiceItems.at(item.index).get('totalPrice').value) }}
                    </ng-container>
                  </mic-table>
                  <div class="flex flex-row flex-row-reverse mr-3">
                    <span>
                      <b>Total: {{ formatCurrency.format(invoiceForm.get('totalPriceSum').value) }}</b>
                    </span>
                  </div>
                </div>
              </div>
              <div>
                <p class="mb-3"><b>Nota Fiscal</b></p>
                <div class="flex gap-3">
                  <mat-form-field class="w-2on6">
                    <mat-label>Número</mat-label>
                    <input matInput type="text" formControlName="invoiceNumber" />
                  </mat-form-field>
                  <mat-form-field class="w-2on6">
                    <mat-label>Data</mat-label>
                    <input matInput placeholder="dd/mm/yyyy" [matDatepicker]="dateTo" autocomplete="off"
                      formControlName="invoiceDate" />
                    <mat-datepicker-toggle matSuffix [for]="dateTo"></mat-datepicker-toggle>
                    <mat-datepicker #dateTo></mat-datepicker>
                  </mat-form-field>
                  <mat-form-field class="w-2on6">
                    <mat-label>Arquivo pdf</mat-label>
                    <input matInput placeholder="Selecione um arquivo" (click)="fillFileInput.click()"
                      autocomplete="off" formControlName="file" />
                    <input hidden #fillFileInput type="file" id="fillFileInput" autocomplete="off"
                      (change)="selectFile($event)" />
                    <mat-hint>Tipo de arquivo: .pdf</mat-hint>
                    <button mat-icon-button matSuffix color="primary" (click)="fillFileInput.click()">
                      <mat-icon>open_in_browser</mat-icon>
                    </button>
                  </mat-form-field>
                </div>
              </div>
              <div>
                <p><b>Status do Pedido: Contato Concessionária</b></p>
                <p>
                  Sempre buscamos o melhor atendimento e mais vendas.<br />Caso você possua um e-mail de contato do
                  solicitante, informe
                  abaixo para que seja enviado um status do atendimento realizado.
                </p>
                <div class="flex flex-row gap-3">
                  <mat-form-field class="w-2on6">
                    <mat-label>E-mail</mat-label>
                    <input matInput type="email" formControlName="contactEmail" />
                  </mat-form-field>
                  <mat-checkbox formControlName="disableEmail">Não sabemos qual é o e-mail</mat-checkbox>
                </div>
              </div>
              <div class="flex flex-row gap-3">
                <button mat-flat-button color="accent" class="mic-btn-icon-left" (click)="submitForm()">
                  <mat-icon>check</mat-icon><span>Confirmar</span>
                </button>
                <button mat-flat-button color="secondary" class="mic-btn-icon-left" (click)="clearForm()">
                  <mat-icon>refresh</mat-icon><span>Limpar</span>
                </button>
              </div>
            </div>
          </form>
        </mat-expansion-panel>
        }
      </mat-accordion>
    </div>
    }
  </div>
</mic-spinner-overlay>

<mic-modal #modalConfirmCancelItem (result)="onModalConfirmCancelItemClosed($event)">
  <ng-template #contentModalConfirmCancelItem>
    <div>
      <p>Tem certeza que deseja cancelar o item?</p>
    </div>
  </ng-template>
</mic-modal>